import { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import AvatarMenu from '../Buttons/AvatarMenu';
import { NavigationRail } from '../Navigation/NavigationRail';
import './global-header.scss';

interface GlobalHeaderProps {
  // TRIL-146: `username` and `routeName` are no longer rendered as inline
  // text in the header — username now surfaces via the AvatarMenu's hover
  // tooltip + the avatar img's alt attribute. Keeping them on the props
  // interface for backward compatibility with the existing caller
  // (Header.tsx); both can be dropped in a future cleanup once any
  // alternate consumer paths are confirmed gone.
  username: string;
  routeName: string;
  firstName: string;
  lastName: string;
  newUser: boolean;
}

// TRIL-146: the sibling <Logout /> button that used to sit next to the rail
// is gone. Logout is now the final entry inside NavigationRail with the
// same icon + tooltip visual contract as every other rail item. The
// canonical logout trigger is `useLogoutFlow` (shared with AvatarMenu).
export const GlobalHeader = (props: GlobalHeaderProps) => {
  const authContext = useContext(AuthContext);
  const { session } = authContext;
  const { firstName, lastName, newUser } = props;

  return (
    <section
      className="APP__USER__GLOBAL__HEADER__ELEMENTS"
      id="User__Global__HEADER"
    >
      {session ? (
        <>
          <div className={'GLOBAL__HEADER'}>
            <AvatarMenu firstName={firstName} lastName={lastName} />
          </div>
          <div className="APP__HEADER__MENU">
            {!newUser && <NavigationRail />}
          </div>
        </>
      ) : (
        <div />
      )}
    </section>
  );
};
